export enum Status {
    NAO_INICIADO = "Não iniciado",
    EM_ANDAMENTO = 'Em andamento',
    PRODUCAO = 'Produção',
    ENCERRADO = 'Encerrado',
    CANCELADO = 'Cancelado',
    SUSPENSO = 'Suspenso',
    INTERROMPIDO = 'Interrompido'
} 